export default __webpack_public_path__ + "static/media/2024 GIS _ GHSI with SEC Acceptance.fafcd46b.pdf";